import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import './ArticleDetail.css';

export default function ArticleDetail() {
    const { slug } = useParams();
    const [article, setArticle] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        async function fetchArticle() {
            try {
                const res = await fetch(`/.netlify/functions/fetch-article-content?slug=${slug}`);
                const data = await res.json();
                if (!res.ok) throw new Error(data.error || 'Failed to fetch article');
                setArticle(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        }
        if (slug) fetchArticle();
    }, [slug]);

    const renderContent = (contentBlocks) => {
        return contentBlocks.map((block, index) => {
            switch (block.type) {
                case 'heading_1': return <h1 key={index}>{block.text}</h1>;
                case 'heading_2': return <h2 key={index}>{block.text}</h2>;
                case 'heading_3': return <h3 key={index}>{block.text}</h3>;
                case 'paragraph': return <p key={index}>{block.text}</p>;
                case 'code':
                    return (
                        <div key={index} className="modern-code-block dark-code">
                            <pre><code>{block.text}</code></pre>
                        </div>
                    );
                case 'callout':
                    return (
                        <div key={index} className="modern-callout">
                            <span className="callout-icon">{block.icon}</span>
                            <div className="callout-text">{block.text}</div>
                        </div>
                    );
                case 'divider': return <hr key={index} className="modern-divider" />;
                case 'bulleted_list_item':
                case 'numbered_list_item':
                    return <li key={index} className="modern-list-item">{block.text}</li>;
                default: return null;
            }
        });
    };

    if (loading) return <div className="center-container"><p>Loading...</p></div>;
    if (error) return <div className="center-container"><h2>Error</h2><p>{error}</p></div>;

    return (
        <div className="center-container article-view">
            <Link to="/articles" className="back-link">← Articles</Link>
            <article>
                <header className="article-header">
                    <h1>{article.title}</h1>
                </header>
                <div className="article-body">
                    {renderContent(article.content)}
                </div>
            </article>
        </div>
    );
}